import type { ReactNode } from 'react'

export type OrganizationRoleKey = 'org:admin' | 'org:member'

export interface OrganizationMember {
  id: string
  clerkUserId: string
  email: string
  firstName: string | null
  lastName: string | null
  imageUrl: string | null
  memberRole: OrganizationRoleKey
  createdAt: Date
  isCurrentUser: boolean
}

export interface OrganizationInvitation {
  id: string
  emailAddress: string
  memberRole: OrganizationRoleKey
  status: 'pending' | 'accepted' | 'revoked'
  createdAt: Date
}

export interface InviteMemberFormData {
  email: string
  memberRole: OrganizationRoleKey
}

export interface MemberRoleBadgeProps {
  memberRole: OrganizationRoleKey
  className?: string
}

export interface MemberRoleSelectProps {
  value: OrganizationRoleKey
  onChange: (memberRole: OrganizationRoleKey) => void
  isDisabled?: boolean
  className?: string
}

export interface SeatUsageAlertProps {
  currentCount: number
  maxCount: number | null
  subscriptionHref: string
  className?: string
}

export interface InviteMemberDialogProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  onInvite: (data: InviteMemberFormData) => Promise<void>
  isLoading?: boolean
  className?: string
}

export interface MembersListSectionProps {
  memberList: OrganizationMember[]
  currentUserId: string | null
  canManageMembers: boolean
  isLoading?: boolean
  onRoleChange: (memberId: string, memberRole: OrganizationRoleKey) => void
  onRemoveMember: (memberId: string) => void
  className?: string
}

export interface InvitationsListSectionProps {
  invitationList: OrganizationInvitation[]
  canManageMembers: boolean
  isLoading?: boolean
  onRevokeInvitation: (invitationId: string) => void
  className?: string
}

export interface MembersTabsContentProps {
  memberList: OrganizationMember[]
  invitationList: OrganizationInvitation[]
  currentUserId: string | null
  canManageMembers: boolean
  isMembersLoading?: boolean
  isInvitationsLoading?: boolean
  onRoleChange: (memberId: string, memberRole: OrganizationRoleKey) => void
  onRemoveMember: (memberId: string) => void
  onRevokeInvitation: (invitationId: string) => void
  toolbarActions?: ReactNode
  className?: string
}

export const ORGANIZATION_ROLE_LABELS: Record<OrganizationRoleKey, string> = {
  'org:admin': 'Admin',
  'org:member': 'Member',
}

export const ORGANIZATION_ROLE_LIST: OrganizationRoleKey[] = ['org:admin', 'org:member']
